import tedClient from 'src/api/tedClient';

const baseUrl = `${process.env.REACT_APP_TED_API}${process.env.REACT_APP_NETDOCS_API_PATH}api/v1/`;

export const oauthLogin = async (authCode) => tedClient.post(`${baseUrl}oauth/login`, { authCode });

export const hasActiveNetdocsLogin = async () => tedClient.get(`${baseUrl}oauth/login`);

export const searchDocuments = async (_, { attributeType, resourceId }) => {
  const { data } = await tedClient.get(`${baseUrl}search/${attributeType}/${resourceId}`);
  return data;
};
